import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { WrapperComponent } from '~core/pages/wrapper/wrapper.component';
import { AuthGuard } from '~modules/auth/guards/auth.guard';
import { MaintenanceGuard } from '~core/guards/maintenance.guard';
import { MaintenancePageComponent } from '~modules/public/pages/maintenance/maintenance-page.component';
import { MaintenanceAdminPageComponent } from '~core/pages/maintenance-admin/maintenance-admin-page.component';

const routes: Routes = [
	{
		path: 'preview',
		canActivate: [MaintenanceGuard],
		loadChildren: () =>
			import('./modules/preview/preview.module').then((m) => m.PreviewModule),
		data: {
			disableNavigation: true,
			skipWebSocket: true,
		},
	},
	{
		// Legacy entry — the public homepage now lives at the site root.
		path: 'home',
		redirectTo: '',
		pathMatch: 'full',
	},
	{
		path: '',
		component: WrapperComponent,
		canActivate: [MaintenanceGuard],
		canActivateChild: [MaintenanceGuard],
		children: [
			{
				path: 'core',
				canActivate: [AuthGuard],
				canActivateChild: [AuthGuard],
				loadChildren: () =>
					import('./core/core.module').then((m) => m.CoreModule),
			},
			{
				path: 'projects',
				canActivate: [AuthGuard],
				canActivateChild: [AuthGuard],
				loadChildren: () =>
					import('./modules/project/project.module').then(
						(m) => m.ProjectModule
					),
			},
			{
				path: 'users',
				canActivate: [AuthGuard],
				canActivateChild: [AuthGuard],
				loadChildren: () =>
					import('./modules/users/users.module').then((m) => m.UsersModule),
			},
			{
				path: 'maintenance-admin',
				canActivate: [AuthGuard],
				component: MaintenanceAdminPageComponent,
			},
			{
				// Public on purpose (no AuthGuard) so logged-out users reach it
				// during maintenance. Renders inside the wrapper for the logo-only
				// header; the parent MaintenanceGuard handles the redirect logic.
				path: 'maintenance',
				component: MaintenancePageComponent,
				data: {
					skipWebSocket: true,
				},
			},
			{
				path: 'auth',
				loadChildren: () =>
					import('./modules/auth/auth.module').then((m) => m.AuthModule),
			},
			{
				path: 'materials',
				canActivate: [AuthGuard],
				canActivateChild: [AuthGuard],
				loadChildren: () =>
					import('~modules/board/boards.module').then((m) => m.BoardsModule),
			},
			{
				// Public website: homepage + sub-pages (incl. /algemene_voorwaarden).
				// Empty path so it sits at the site root; placed last so the specific
				// authenticated paths above match first. Rendered without app chrome.
				path: '',
				loadChildren: () =>
					import('./modules/public/public.module').then((m) => m.PublicModule),
				data: {
					disableNavigation: true,
					skipWebSocket: true,
				},
			},
		],
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes, {
		initialNavigation: 'enabledBlocking',
		paramsInheritanceStrategy: 'always',
		// enableTracing: true
	})],
	exports: [RouterModule],
})
export class AppRoutingModule {}
